/* eslint-disable no-plusplus */
/* eslint-disable one-var */
/* eslint-disable no-var */
import i18next from 'i18next';
import moment from 'moment';

import { languages, errors, stakeholderModel } from '../constants/index.js';

// eslint-disable-next-line max-len
export const PASS_REGEX = /^(?!.*([a-zA-Z0-9])\1{2})(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^a-zA-Z\d\u0600-\u06FF])[\w!@#$%^&*()-_+=[\]{};':"\\|,.<>/?]{8,16}$/;
export const MAX_INT_REGEX = /^(0|([1-9]\d{0,8}|1\d{0,8}|2([0-9]{0,8}|1([0-9]{0,7}|2([0-9]{0,6}|3([0-9]{0,5}|4([0-9]{0,4}|5([0-9]{0,3}|6([0-9]{0,2}|7([0-9]{0,1})?)))))))))$/;
export const GTIN_REGEX = /^\d{14}$/;
export const QUANTITY_REGEX = /^\d+$/;
export const SN_REGEX = /^[A-Z0-9!\\"%&'()*+,-./:;<=>?_]{1,20}$/;
export const BN_REGEX = /^[A-Z0-9!\\"%&'()*+,-./:;<=>?_]{1,20}$/;
export const XD_REGEX = /^\d{2}[-/]\d{2}[-/]\d{4}$/;


export const additionsClasses = (additions = [], style) =>
  additions.map(addition => style[addition]);

export const getLangFromStorage = () => localStorage.getItem('locale') || languages.EN;

export const setLang = lang => localStorage.setItem('locale', lang);

export const locale = getLangFromStorage() || languages.EN;

export const changeLang = switchedLang => {
  const { EN } = languages;
  const removedClass = switchedLang === EN ? 'rtl' : 'ltr';
  const addedClass = switchedLang === EN ? 'ltr' : 'rtl';
  document.body.classList.remove(removedClass);
  document.body.classList.add(addedClass);

  if (switchedLang !== getLangFromStorage()) {
    setLang(switchedLang);
    i18next.changeLanguage(switchedLang);
    i18next.reloadResources();
  }
};


export const fixedEncodeURIComponent = URI => {
  const encodeConnectors = c => `%${c.charCodeAt(0).toString(16)}`;

  return encodeURIComponent(URI).replace(/[!'()*]/g, encodeConnectors);
};


export const getErrors = response => {
  let errorCode;
  if (response && response.data && response.data.responseCode) {
    errorCode = response.data.responseCode;
  } else if (response && response.status === 403) {
    errorCode = 403;
  } else if (response && response.status === 404) {
    errorCode = 404;
  } else if (response && response.status === 413) {
    errorCode = 413;
  } else if (response && response.status === 400) {
    errorCode = 400;
  } else if (response && response.status === 401) {
    // errorCode = 401;
  } else if (response && response.msg === 'Network Error') { // TODO: Change Error check
    errorCode = errors.NETWORK_ERROR_TITLE;
  } else {
    errorCode = errors.UNEXPECTED_ERROR;
  }

  return [ errorCode ];
};

export const stakeholderTypeMapper = type => {
  if (!type) {
    return type;
  }
  if (!isNaN(type)) {
    return type;
  }
  switch (type.toLowerCase()) {
    case 'manufacturer':
      return stakeholderModel.TYPE_VALUES.MANUFACTURER;
    case 'warehouse':
      return stakeholderModel.TYPE_VALUES.WAREHOUSE;
    case 'pharmacy':
      return stakeholderModel.TYPE_VALUES.WAREHOUSE;
    case 'consumptionCenter':
      return stakeholderModel.TYPE_VALUES.WAREHOUSE;
    case 'reimbursementAgency':
      return stakeholderModel.TYPE_VALUES.WAREHOUSE;
    default:
      return null;
  }
};

export const splitMultiple = (str, ...separator) => {
  const res = [];
  let start = 0;
  for (let i = 0; i < str.length; i++) {
    if (!separator.includes(str[i])) {
      // eslint-disable-next-line no-continue
      continue;
    }
    res.push(str.substring(start, i));
    start = i + 1;
  }

  return res;
};

export const dataURLtoFile = (dataurl, filename) => {

  var arr = dataurl.split(','),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([ u8arr ], filename, { type: mime });
};

export const isValidDateRange = (startDate, endDate) => {
  if (startDate && endDate) {
    const start = moment(startDate, 'DD-MM-YYYY');
    const end = moment(endDate, 'DD-MM-YYYY');

    return start <= end;
  }

  return true;
};
